import { faCalendarDays, faList } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Flex, Segmented, Space } from "antd"
import VSpace from "../common/VSpace"
import { useState } from "react"
import ConsultationsCalendar from "../calendar/ConsultationsCalendar"
import ScheduledJobsList from "./ScheduledJobsList"

type Props = {
  customerId?: number
}

type ViewOption = 'list-view' | 'calendar-view'

const ScheduledJobs = ({customerId}: Props) => {
  const [selectedView, setSelectedView] = useState<ViewOption>('list-view')

  if (customerId === undefined) {
    return <></>
  }

  return <section>
    <VSpace>
      <Flex justify="space-between">
        <Space>
          <FontAwesomeIcon icon={faCalendarDays} />
          <strong>Customer Schedule</strong>
        </Space>
        <Segmented
          value={selectedView}
          onChange={setSelectedView}
          options={[
            {
              value: 'list-view',
              label: 'List View',
              icon: <FontAwesomeIcon icon={faList} />
            },
            {
              value: 'calendar-view',
              label: 'Calendar View',
              icon: <FontAwesomeIcon icon={faCalendarDays} />
            },
          ]}
        />
      </Flex>

      {selectedView === 'list-view' && <ScheduledJobsList customerId={customerId} />}
      {selectedView === 'calendar-view' && <ConsultationsCalendar customerId={customerId} />}
    </VSpace>
  </section>
}

export default ScheduledJobs